module.exports = __webpack_public_path__ + "img/leftcalf-ectomorph-male.906a84fa.svg";